/**
 * Napoli — central image registry.
 *
 * All landing-page imagery lives here. To swap any photo, change one line.
 * Sources: curated moody-editorial Italian food / restaurant photos from
 * Unsplash (verified 200 OK at build time, content-checked for fit).
 */

const u = (id, w = 1600, q = 80) =>
  `https://images.unsplash.com/${id}?w=${w}&q=${q}&auto=format&fit=crop`;

// --- Hero ------------------------------------------------------------------
// Tagliatelle + seared steak in a dark pan; close-up, candlelight feel.
export const HERO_IMAGE = u("photo-1551183053-bf91a1d81141", 2000);

// --- Section 2: La Nostra Storia ------------------------------------------
// Overhead — three plates of pasta + red wine on linen; refined, intimate.
export const STORY_IMAGE = u("photo-1481931098730-318b6f776db0", 1400);

// --- Section 3: La Cucina (4 menu cards) ----------------------------------
// Antipasti — rustic cheese stack, dark moody styling.
export const MENU_ANTIPASTI = u("photo-1559561853-08451507cbe7", 1200);
// Primi — spaghetti twirled on fork, deep black background.
export const MENU_PASTA = u("photo-1556761223-4c4282c73f77", 1200);
// Secondi — sliced bistecca on a dark wooden board.
export const MENU_SECONDI = u("photo-1558030006-450675393462", 1200);
// Dolci — close-up tiramisù slice, layered, cocoa-dusted.
export const MENU_DOLCI = u("photo-1571877227200-a0d98ea607e9", 1200);

// --- Section 6: Riserva il tuo posto --------------------------------------
// Red wine + grapes in dark moody lighting.
export const WINE_IMAGE = u("photo-1547595628-c61a29f496f0", 1400);

// --- Misc (kept for future use; e.g. Branding admin preview) --------------
export const INTERIOR_IMAGE = u("photo-1414235077428-338989a2e8c0", 1400);

export const ALL_IMAGES = [
  HERO_IMAGE,
  STORY_IMAGE,
  MENU_ANTIPASTI,
  MENU_PASTA,
  MENU_SECONDI,
  MENU_DOLCI,
  WINE_IMAGE,
  INTERIOR_IMAGE,
];
